module.exports = {"TXTCLI_Join_a_club":{"id":"TXTCLI_Join_a_club","defaultMessage":"Einem Club beitreten","track":"Join a club"}}